import * as KatalMetrics from '@amzn/katal-metrics';
import KatalMetricsDriverSushi from '@amzn/katal-metrics-driver-sushi';
import {STAGE, stage} from "src/config";
import KatalMetricsDriverConsoleLogJson from "@amzn/katal-metrics/lib/driver/KatalMetricsDriverConsoleLogJson";

const metricsErrorHandler = (err) => {
    console.error(err)
};

const makeMetricsDriver = (): KatalMetrics.MetricsDriver => {
    if (stage === STAGE.PROD) {
        return new KatalMetricsDriverSushi.Builder()
            .withDomainRealm('prod', 'USAmazon')
            .withErrorHandler(metricsErrorHandler)
            .build();
    } else if (stage === STAGE.TEST) {
        return new KatalMetricsDriverSushi.Builder()
            .withDomainRealm('test', 'USAmazon')
            .withErrorHandler(metricsErrorHandler)
            .build();
    } else {
        //Metrics will be logged in the console for Development purpose
        return new KatalMetricsDriverConsoleLogJson();
    }
};

const metricsDriver = makeMetricsDriver();
const initialMetricsContext = new KatalMetrics.Context.Builder()
    .withSite('SNOWNxt')
    .withServiceName('SNOWAppWebsite')
    .build();
const katalMetricsPublisher = new KatalMetrics.Publisher(
    metricsDriver,
    metricsErrorHandler,
    initialMetricsContext);

export default katalMetricsPublisher;
